export default __webpack_public_path__ + "static/media/File8.4b95633e.pdf";